<template>
	<div class="p_m_t_30">
		<span class="type_size_20">{{name}}作业概览</span>
		<div class="p_flex p_m_t_30">
			<div class="p_f_1 p_b_r content_center">
				<div class="subject_color type_size_18">提交率</div>
				<div class="subject_color type_size_30 p_m_t_14">{{submitpercentage}}%</div>
				<div class="type_size_16 content_color p_m_t_14">{{submitalready}}人已提交</div>
				<div class="type_size_16 content_color p_m_t_14">{{submitno}}人未提交</div>
			</div>
			<div class="p_f_1 p_b_r content_center">
				<div class="subject_yellow type_size_18">批改率</div>
				<div class="subject_yellow type_size_30 p_m_t_14">{{correctpercentage}}%</div>
				<div class="type_size_16 content_color p_m_t_14">{{correctalready}}人已批改</div>
				<div class="type_size_16 content_color p_m_t_14">{{correctno}}人未批改</div>
			</div>
			<div class="p_f_1 content_center">
				<div class="subject_blue type_size_18">平均时间</div>
				<div class="subject_blue type_size_18 p_m_t_14">{{formatTime(average_time)}}</div>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
	  props: {
		  ids:String
	  },
	  name:"Deatiloverview",
	  data(){
		  return{
			  name:"",  //几班
			  submitalready:"" , //已提交
			  submitno:"",//未提交
			  submitpercentage:""  ,//提交百分比
			  correctalready:"" , //已批改
			  correctno:"", //未批改
			  correctpercentage:"", //批改率
			  average_time:"" //平均用时
		  }
	  },
		methods:{
			formatTime(second) {
				function padStart(num) {
					return (num|0).toString().padStart(2,'0')
				}

				return padStart(second/60/60)+':'+padStart(second/60%60)+':'+padStart(second%60)
			}
		},
		mounted() {
			// console.log(this.ids)
			this.$request.ajax(this).post("/api_teacher/analysis_report",{
           		job_publish_id: this.ids
			}).then(res=>{
				// console.log(res)
				this.name=res.data.classLevel.name						//几班
				this.submitalready=res.data.submit_rate_def.already				// 已提交
				this.submitno=res.data.submit_rate_def.no					//   未提交
				this.submitpercentage=res.data.submit_rate_def.percentage		//  提交百分比
				this.correctalready=res.data.correct_rate_def.already			//   已批改
				this.correctno=res.data.correct_rate_def.no   				//未批改
				this.correctpercentage=res.data.correct_rate_def.percentage  //   批改率
				this.average_time=res.data.average_time   //平均用时
			})
		}
    }
</script>

<style lang="scss" scoped>
.content_center {
	text-align: center;
}
.content_color {
	color: #676767;
}
.subject_blue{
	color: #3785FC;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/analyse/commponents/deatiloverview.vue